import dataFetcher from "../dataFetcher";

export const getCheckBookService = async (pagina) => {
  try {
    const res = await dataFetcher.post("/usuario/obtenerchequeros", {pagina});
    return {
      data: res.data,
      success: true,
    };
  } catch (error) {
    return {
      error: error.response.data,
      success: false,
    };
  }
};

export const assignCheckBookService = async (cheeckBookData) => {
  try {
    const res = await dataFetcher.post(
      "/carta/asignarchequero",
      cheeckBookData
    );
    return {
      data: res.data,
      success: true,
    };
  } catch (error) {
    return {
      error: error.response.data,
      success: false,
    };
  }
};
